const downloadFile = (url, filename) => {
  const a = document.createElement('a');
  a.href = url;
  a.download = filename ?? 'download';
  a.click();
  a.remove();
};

export default downloadFile;
